















































import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

import { Vehicle } from '@/modules/Vehicle/interfaces/vehicle'
import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import { RecordType, RecordTypeAdditionalInfo, RecordTypeFormItem } from '@/modules/RecordType/interfaces/record-type'
import { vehicleCoverage } from '@/modules/Vehicle/helpers/vehicle'

@Component({
  components: {
    FoldingCard,
    AppDialog
  }
})
export default class VehicleDetailDetail extends Vue {
  @Prop({ type: Object as () => Vehicle }) readonly vehicle!: Vehicle

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay

  vehicleCoverage = vehicleCoverage

  get policyRoute () {
    return {
      name: 'PolicyDetailDetail',
      params: {
        id: this.vehicle.policy.id
      }
    }
  }

  get quoteRoute () {
    return {
      name: 'QuoteDetailDetail',
      params: {
        id: this.vehicle.quote.id
      }
    }
  }
}
